export default __webpack_public_path__ + "static/blob3-4837619b8068ee8b91cd71af4c3778e5.svg";